var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 7.375H8.625V3.625C8.625 3.45924 8.55915 3.30027 8.44194 3.18306C8.32473 3.06585 8.16576 3 8 3C7.83424 3 7.67527 3.06585 7.55806 3.18306C7.44085 3.30027 7.375 3.45924 7.375 3.625V7.375H3.625C3.45924 7.375 3.30027 7.44085 3.18306 7.55806C3.06585 7.67527 3 7.83424 3 8C3 8.16576 3.06585 8.32473 3.18306 8.44194C3.30027 8.55915 3.45924 8.625 3.625 8.625H7.375V12.375C7.375 12.5408 7.44085 12.6997 7.55806 12.8169C7.67527 12.9342 7.83424 13 8 13C8.16576 13 8.32473 12.9342 8.44194 12.8169C8.55915 12.6997 8.625 12.5408 8.625 12.375V8.625H12.375C12.5408 8.625 12.6997 8.55915 12.8169 8.44194C12.9342 8.32473 13 8.16576 13 8C13 7.83424 12.9342 7.67527 12.8169 7.55806C12.6997 7.44085 12.5408 7.375 12.375 7.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus1);
export default __webpack_public_path__ + "static/media/Plus (1).cf48434cc636b56b727326b10db9ccdf.svg";
export { ForwardRef as ReactComponent };